// extracted by mini-css-extract-plugin
export default {"content":"mentionsLegales_content__LigMC"};